import React, { useState } from 'react';
import { NumberInput } from '../inputs/NumberInput';
import { Button, Form, Modal } from 'react-bootstrap';

interface RefundModalProps {
  show: boolean;
  title: string;
  fullRefund: boolean;
  onClose: () => void;
  onSubmit: (refundAmount: number | null, notes: string, deactivate: boolean) => void;
}

const RefundModal: React.FC<RefundModalProps> = ({
  show,
  title,
  fullRefund,
  onClose,
  onSubmit
}) => {
  const [refundAmountError, setRefundAmountError] = useState(false);

  const [refundAmount, setRefundAmount] = useState<number | null>(null);
  const [refundNotes, setRefundNotes] = useState('');
  const [deactivate, setDeactivate] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if ((refundAmount === null || isNaN(refundAmount)) && !fullRefund) {
      setRefundAmountError(true);
      return;
    }
    e.preventDefault();
    onSubmit(refundAmount, refundNotes, deactivate);
    setRefundAmount(null);
    setRefundNotes('');
    setDeactivate(false);
    onClose();
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          {!fullRefund && (
            <Form.Group
              controlId="refundAmount"
              className="mb-3"
            >
              <Form.Label>Refund amount per registration</Form.Label>
              <NumberInput
                value={refundAmount ?? ''}
                onChange={(e) => setRefundAmount(parseFloat(e.target.value))}
                placeholder="Enter refund amount"
              />
              {refundAmountError && (
                <div className="text-danger">Please enter a valid refund amount.</div>
              )}
            </Form.Group>
          )}

          <Form.Group
            controlId="refundNotes"
            className="mb-3"
          >
            <Form.Label>Refund Notes</Form.Label>
            <Form.Control
              type="text"
              value={refundNotes}
              onChange={(e) => setRefundNotes(e.target.value)}
              placeholder="Enter refund notes"
            />
          </Form.Group>

          <Form.Group
            controlId="deactivateCheckbox"
            className="mb-3"
          >
            <Form.Check
              type="checkbox"
              label="Deactivate Registration?"
              checked={deactivate}
              onChange={(e) => setDeactivate(e.target.checked)}
            />
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button
              variant="secondary"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={!fullRefund && (refundAmount === null || isNaN(refundAmount))}
            >
              OK
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default RefundModal;
